/* eslint-disable react/sort-comp */
import React from 'react';
import classNames from 'classnames';
import _ from 'underscore';
import { ICheckboxState, ICheckboxProps } from './types';

export class Checkbox extends React.Component<ICheckboxProps, ICheckboxState> {
  // for now eslint-plugin-react doesn't recognize `getDerivedStateFromProps`
  // which is introduced in React 16.3
  private el: HTMLInputElement | null = null;

  static defaultProps: Partial<ICheckboxProps> = {
    inline: false,
    checked: false,
    indeterminate: false,
    children: null,
    className: 'checkbox',
    disabled: false,
    id: null,
    name: null,
    value: '',
    ariaLabel: undefined,
  };

  static getDerivedStateFromProps(nextProps: ICheckboxProps, prevState: ICheckboxState): ICheckboxState {
    return {
      id: nextProps.id || prevState.id || _.uniqueId('checkbox-'),
    };
  }

  constructor(props: ICheckboxProps) {
    super(props);
    this.state = { } as ICheckboxState;
  }

  componentDidMount() {
    if (this.props.indeterminate === true) {
      this.el.indeterminate = this.props.indeterminate;
    }
  }

  componentDidUpdate(previousProps: ICheckboxProps) {
    if (previousProps.indeterminate !== this.props.indeterminate) {
      this.el.indeterminate = this.props.indeterminate;
    }
  }

  render() {
    const {
      id,
    } = this.state;

    const {
      inline,
      checked,
      children,
      className,
      disabled,
      name,
      value,
      onChange,
      ariaLabel,
    } = this.props;

    return inline ? (
      <label className={classNames('checkbox-inline', { disabled })} htmlFor={id}>
        <input
          type="checkbox"
          checked={checked}
          disabled={disabled}
          id={id}
          name={name}
          value={value}
          onChange={onChange}
          ref={(el) => { this.el = el; }}
          aria-label={ariaLabel}
        />
        {children}
      </label>
    ) : (
      <div className={classNames(className)}>
        <label htmlFor={id}>
          <input
            type="checkbox"
            checked={checked}
            disabled={disabled}
            id={id}
            name={name}
            value={value}
            onChange={onChange}
            ref={(el) => { this.el = el; }}
            aria-label={ariaLabel}
          />
          {children}
        </label>
      </div>
    );
  }
}
